import {apiBase} from 'api/base.js';

class InstantTakeStatusAPI {
  show(jobName) {
    return apiBase.get(`/admin/instant_rake_status?job_name=${jobName}`);
  }
}

export const instantTakeStatusAPI = new InstantTakeStatusAPI();
